/* TODO fix these by using a link styled button */
/* eslint-disable jsx-a11y/anchor-is-valid */ 
/* eslint-disable-next-line no-script-url */ 

import React from 'react';
import '../../../styles/globals.css'
import { Box } from '@mui/material'
import karmaStyles from '../../../styles/KarmaPool.module.css'
import { useKarmaPoolContext } from '../../../state/KarmaPoolContext';

function DashboardLogoutFooterComponent() {

    const karmaContext = useKarmaPoolContext();

    return (
        <Box sx={{ marginBottom: "3rem"}}>
            <p className={karmaStyles.homepageDescription}>
                <a href={"javascript:void(0)"} onClick={() => {
                    window.localStorage.removeItem("jwtAuthToken");
                    
                    karmaContext.setLocal(prevValue => {
                        return { ...prevValue, user: null };
                    });
                    karmaContext.setLocal(prevValue => {
                        return { ...prevValue, notifications: []};
                    });

                    window.location.href = "/karma";
                }}>
                    log out
                </a>
            </p>
        </Box>
    );
}

export default DashboardLogoutFooterComponent;
